import {CursorBasedPaginationResponse} from 'api/common';
import React from 'react';
import InfiniteScroll, {Props} from 'react-infinite-scroll-component';

interface AppInfiniteScrollContainerProps<T extends CursorBasedPaginationResponse<any>>
    extends Omit<Props, 'children' | 'dataLength' | 'hasMore' | 'loader'> {
    children: React.ReactNode;
    data?: T;
}
const AppInfiniteScrollContainer = <T extends CursorBasedPaginationResponse<any>>({
    children,
    data,
    ...props
}: AppInfiniteScrollContainerProps<T>) => {
    return (
        <InfiniteScroll
            height={'calc(100vh - 120px)'}
            scrollableTarget="scrollableDiv"
            dataLength={data?.nodes.length ?? 0}
            hasMore={data?.pageInfo.hasNextPage ?? false}
            loader="Loading More..."
            {...props}
        >
            {children}
        </InfiniteScroll>
    );
};

export default AppInfiniteScrollContainer;
